import { Redirect } from "react-router-dom";

export const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

//url for production
export var url = "";
if (process.env.NODE_ENV === "development") {
  url = "";
} else {
  url = window.location.host.split("/")[1];
  if (url) {
    url = `/${window.location.host.split("/")[1]}`;
  } else url = process.env.PUBLIC_URL; /// ADD YOUR CPANEL SUB-URL
}

//Function to validate and return errors for a form
export const checkForm = (formData) => {
  let errorState = {};
  Object.keys(formData).forEach((item) => {
    if (formData[item] === null || formData[item] === "") {
      errorState[item] = "This field is required";
    }
  });
  return errorState;
};

//Function that returns the first or first two letters from a name
export const findUpper = (string) => {
  let extractedString = [];

  for (var i = 0; i < string.length; i++) {
    if (string.charAt(i) === string.charAt(i).toUpperCase() && string.charAt(i) !== " ") {
      extractedString.push(string.charAt(i));
    }
  }
  if (extractedString.length > 1) {
    return extractedString[0] + extractedString[1];
  } else {
    return extractedString[0];
  }
};

//Function that calculates the from current date
export const setDeadline = (days) => {
  let todayDate = new Date();
  var newDate = new Date(todayDate);
  newDate.setDate(newDate.getDate() + days);
  return newDate;
};

// Function to set deadline for projects
export const setDeadlineDays = (deadline) => {
  var currentDate = new Date();
  var difference = deadline.getTime() - currentDate.getTime();
  var days = Math.ceil(difference / (1000 * 3600 * 24));
  return days;
};

//Date formatter function
export const dateFormatterAlt = (date, reverse) => {
  let d = date.getDate();
  let m = date.getMonth();
  let y = date.getFullYear();
  reverse ? (date = m + "-" + d + "-" + y) : (date = y + "-" + d + "-" + m);
  return date;
};

//Date formatter function
export const dateFormatter = (date, reverse) => {
  var dateformat = date.split("-");
  //var date = dateformat[1]+"-"+dateformat[2]+"-"+dateformat[0];
  reverse
    ? (date = dateformat[2] + "-" + dateformat[0] + "-" + dateformat[1])
    : (date = dateformat[1] + "-" + dateformat[2] + "-" + dateformat[0]);
  return date;
};

//Month Names
export const monthNames = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

//todays Date
export const todaysDate = new Date();

// Function to structure date ex : Jun 4, 2011;
export const getDateStructured = (date) => {
  let d = date.getDate();
  let m = date.getMonth();
  let y = date.getFullYear();
  let final = monthNames[m] + " " + d + ", " + y;
  return final;
};

// Function to structure date ex: YYYY-MM-DD
export const setDateForPicker = (rdate) => {
  let d = rdate.getDate();
  d < 10 && (d = "0" + d);
  let m = rdate.getMonth() + 1;
  m < 10 && (m = "0" + m);
  let y = rdate.getFullYear();
  rdate = y + "-" + m + "-" + d;

  return rdate;
};

//current Time
export const currentTime = () => {
  var hours = todaysDate.getHours();
  var minutes = todaysDate.getMinutes();
  var ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12;
  hours = hours ? hours : 12; // the hour '0' should be '12'
  minutes = minutes < 10 ? "0" + minutes : minutes;
  var strTime = hours + ":" + minutes + " " + ampm;
  return strTime;
};

//Percentage calculation
export const calcPercentage = (str1, str2) => {
  let result = Number(str2) / Number(str1);
  result = result * 100;
  return Math.floor(result);
};

//shortens a long string
export const truncate = (str, n) => {
  return str.length > n ? str.substr(0, n - 1) + " " + truncate(str.substr(n - 1, str.length), n) : str;
};

export const RedirectAs404 = ({ location }) => (
  <Redirect to={Object.assign({}, location, { state: { is404: true } })} />
);

// returns upload url
export const getUploadParams = () => {
  return { url: "https://httpbin.org/post" };
};

// Converts KB to MB
export const bytesToMegaBytes = (bytes) => {
  let result = bytes / (1024 * 1024);
  return result.toFixed(2);
};

export const bulkActionOptions = [
  { value: "suspend", label: "Suspend User" },
  { value: "delete", label: "Delete User" },
];

export function utilsFormatPriceInString(inputString) {
  try {
    // Regular expression to detect a number in the format "Rp.15000.00" within square brackets
    const regex = /\[Rp\.(\d+(?:\.\d+)*)\]/g; // Added 'g' flag for global matching

    // Function to format each matched price
    const formatMatch = (match, price) => {
      // Remove the '.00' if it exists
      let rawPrice = price.replace('.00', '');
      
      // Format the number with thousand separators
      const formattedPrice = parseFloat(rawPrice).toLocaleString('id-ID', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });

      // Return the formatted match
      return `[Rp.${formattedPrice}]`;
    };

    // Use replace with a callback function to format each price match
    const formattedString = inputString.replace(regex, formatMatch);

    return formattedString;
  } catch (error) {
    console.error('Error formatting price:', error);
    // Return the original string in case of any error
    return inputString;
  }
}

export const utilsRemoveItemByValue = (arr, value) => arr.filter(item => item !== value);

// Reads the "permission" object from localStorage, safely defaulting to {} when absent/unparsable
export const getPermission = () => {
  try {
    return JSON.parse(localStorage.getItem("permission")) || {};
  } catch {
    return {};
  }
};

// class-validator items ({ target, property, constraints }) carry the text in constraints; never stringify target
const errorItemText = (item) => {
  if (typeof item !== "object" || item === null) return item;
  if (item.constraints) return Object.values(item.constraints).join(", ");
  return item.detail || item.message || JSON.stringify(item);
};

export const getApiErrorMessage = (response, fallbackMessage = "Terjadi kesalahan. Silakan coba lagi.") => {
  if (!response) return fallbackMessage;

  if (response.status === "No Server Response" || !response.status) {
    return "Tidak dapat terhubung ke server. Silakan periksa koneksi internet Anda.";
  }

  const data = response.data;
  if (data) {
    if (typeof data === "string" && data.trim() !== "" && !data.trim().startsWith("<")) {
      return data.trim();
    }
    if (typeof data.message === "string" && data.message.trim() !== "") {
      return data.message;
    }
    if (Array.isArray(data.message) && data.message.length > 0) {
      return data.message
        .map(errorItemText)
        .filter(Boolean)
        .join(", ");
    }
    if (typeof data.message === "object" && data.message !== null) {
      const msg = data.message.detail || data.message.message || data.message.error;
      if (typeof msg === "string" && msg.trim() !== "") return msg;
    }
    if (typeof data.error === "string" && data.error.trim() !== "" && data.error !== "Bad Request") {
      return data.error;
    }
    if (Array.isArray(data.errors) && data.errors.length > 0) {
      return data.errors
        .map(errorItemText)
        .filter(Boolean)
        .join(", ");
    }
    if (typeof data.errors === "object" && data.errors !== null) {
      return Object.values(data.errors)
        .map(errorItemText)
        .filter(Boolean)
        .join(", ");
    }
    if (typeof data.detail === "string" && data.detail.trim() !== "") {
      return data.detail;
    }
    if (typeof data.msg === "string" && data.msg.trim() !== "") {
      return data.msg;
    }
    if (typeof data.description === "string" && data.description.trim() !== "") {
      return data.description;
    }
  }

  if (typeof response.message === "string" && response.message.trim() !== "") {
    return response.message;
  }

  if (response.status === 409 || response.statusText === "Conflict") {
    return "Link name already exist";
  }
  if (response.status === 400 || response.status === 422) {
    return "Data yang dikirim tidak valid. Silakan periksa kembali form Anda.";
  }
  if (response.status === 401) {
    return "Sesi login telah berakhir. Silakan login kembali.";
  }
  if (response.status === 403) {
    return "Anda tidak memiliki izin untuk melakukan tindakan ini.";
  }
  if (response.status >= 500) {
    return "Terjadi kesalahan pada server. Silakan coba beberapa saat lagi.";
  }

  return response.statusText || fallbackMessage;
};
